export const slidesVisible = 1;
export const gap = 10;
export const align = 'center';
export const orientation = 'h';
export const activePage = 0;
export const slidesPerPage = 1;
export const transitionSpeed = 1000;
